import React from "react";
import classes from "../memory.module.css";
import TypographyInline from "../../../components/Typography/TypographyInline";
import { BASE } from "../../../utils/constants/colors";
import { fontWeight, ICON_LABELS } from "../../../utils/constants/UI";
import Button from "../../../components/Buttons/Button";
import { STRINGS } from "../strings";

const SummaryItem = ({ type, title, description, onEdit, onDelete }) => {
  return (
    <div className={classes.summaryItem}>
      <div className={classes.summaryInfo}>
        <span className={classes.typeBadge}>{type}</span>
        <TypographyInline
          label={title}
          size="lg"
          fontWeight={fontWeight.BOLD}
          color={BASE.BLACK}
        />
        {description && (
          <div
            className={classes.summaryContent}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </div>
      <div className={classes.actionButtons}>
        <Button
          label="Edit"
          variant="ghost"
          size="sm36"
          onClick={onEdit}
          LeftIcon={ICON_LABELS.EDIT}
        />
        <Button
          label="Delete"
          variant="ghost"
          size="sm36"
          onClick={onDelete}
          className={classes.deleteBtn}
          LeftIcon={ICON_LABELS.DELETE_OUTLINE}
        />
      </div>
    </div>
  );
};

export default SummaryItem;
